import React, { FC } from 'react';
import styled from 'styled-components';
import { Typography } from '@clds/typography';
import { useMixin } from '@clds/component-theme';
import { ButtonSize } from '@clds/button';
import { CopyButton } from './components/CopyButton';
import { SingleCodeSnippetProps } from './types';
import { StyledCode } from './CodeSnippet.styled';
import { CodeSnippetLayout } from './components/CodeSnippetLayout';
import { t } from './CodeSnippetTheme';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSdkCodeLayout = styled(StyledCode)`
  pre {
    min-height: 30px;
    height: 100%;
  }
`;

export const SingleCodeSnippet: FC<React.PropsWithChildren<SingleCodeSnippetProps>> = ({
  header,
  snippet,
  language,
  syntax,
  onCopy,
  title,
  parsedUrl,
  headerSize = 'sm',
  ...rest
}) => {
  const buttonSize = useMixin(t.header.sizeVariant[headerSize].buttonSize) as ButtonSize;
  return (
    <CodeSnippetLayout
      header={
        header || (
          <HeaderWrapper>
            <Typography size="xs" type="regular">
              {title === '' ? title : title || language}
            </Typography>
            <CopyButton contentToCopy={snippet} onCopy={onCopy} tone="plain" size={buttonSize} />
          </HeaderWrapper>
        )
      }
      {...rest}
    >
      <StyledSdkCodeLayout parsedUrl={parsedUrl} syntax={syntax}>
        {snippet}
      </StyledSdkCodeLayout>
    </CodeSnippetLayout>
  );
};
